/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_On_MapInputs */

const fr_view_on_map = /** @type {(inputs: View_On_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir sur la carte`)
};

const en_view_on_map = /** @type {(inputs: View_On_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View on map`)
};

/**
* | output |
* | --- |
* | "View on map" |
*
* @param {View_On_MapInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const view_on_map = /** @type {((inputs?: View_On_MapInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_On_MapInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_view_on_map(inputs)
	return en_view_on_map(inputs)
});